import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import Balcony from './components/Balcony';
import Benefits from './components/Benefits';
import BottomMark from './components/BottomMark';
import Capture from './components/Capture';
import Fits from './components/Fits';
import MultiScene from './components/MultiScene';
import Position from './components/Position';
import Recognised from './components/Recognised';
import SectionC from './components/SectionC';
import SectionE from './components/SectionE';
import SectionF from './components/SectionF';
import SectionG from './components/SectionG';
import SmartControl from './components/SmartControl';
import SmartSystem from './components/SmartSystem';
import Works from './components/Works';
import Modal from './modal';

export default function Com() {
    const { useState, useRouter, useLang, Link } = useGlobal();
    const { locale } = useRouter();
    const [showModal, setShowModal] = useState(false);
    const { t } = useLang('powerstream.modal');

    return (
        <>
            <Position />
            <SectionC />
            {/* {['de'].includes(locale) ? <DESolution /> : <Solution />} */}
            {['de'].includes(locale) && <Balcony />}
            <Capture />
            <MultiScene />
            <Works />
            <SmartSystem />
            <SectionE />
            <SmartControl />
            <SectionF />
            <SectionG />
            <Fits />
            {/* <UserSay /> */}
            <Benefits />
            {['de', 'eu', 'uk'].includes(locale as string) && <Recognised />}
            {locale === 'de' && (
                <div className="wtb-box">
                    <div className="box-inner">
                        <div className="content-text">
                            <p className="title">{t('title1')}</p>
                            <p className="desc">{t('desc')}</p>
                            <Link
                                href="/where-to-buy"
                                className="btn"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'activity_store',
                                    page_name: 'de/powerstream',
                                    button_name: t('btn'),
                                }}
                            >
                                {t('btn')}
                            </Link>
                        </div>
                        <div className="content-img">
                            <NextImage
                                webpSrc={require('@publicLocal/power-stream/modal/1.webp')}
                                src={require('@publicLocal/power-stream/modal/1.png')}
                                alt={t('title')}
                                aria-label={t('title')}
                            />
                        </div>
                    </div>
                </div>
            )}
            <BottomMark />
            {showModal && <Modal callBack={() => setShowModal(false)} />}
        </>
    );
}
